import Lockup from '../../components/Lockup';

export function HeaderTitle() {
    return (
        <div className="h-[52px] w-full bg-cb-blue-950 flex items-center justify-center text-white border-b-[0.5px] border-b-cb-iron-300">
            <Lockup height={30} />
        </div>
    );
}
